exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-result-title[data-v-92ae046e]{color:#0696d7;font-family:artifaktElementBold;font-size:14px;font-weight:700}", ""]);

// exports
